import { deletee, get, post, put } from './';
import { IRegion } from '../types/';
import { AxiosPromise } from 'axios';

export type IGetbrandRes = IRegion[];
export const getRegionsService = (): AxiosPromise<IGetbrandRes> => {
  return get({
    subUrl: '/regions'
    // params: { for_app: false }
  });
};

export type IAddRegionData = {
  name: string;
};
export const addRegionService = (
  data: IAddRegionData
): AxiosPromise<IRegion> => {
  return post({
    subUrl: '/regions/add',
    data: data
  });
};

export const deleteRegionService = (id: string) => {
  return deletee({
    subUrl: '/regions',
    params: { id }
  });
};

export type IEditRegonData = {
  id: string;
  name: string;
};
export const editRegionSerive = (data: IEditRegonData) => {
  return put({
    subUrl: '/regions',
    data
  });
};
